<section class="quote-progress" aria-label="Selected quote">
  <h5 class="quote-progress__heading" data-testid="selected-quote-heading">
    SELECTED QUOTE
  </h5>
  <div class="quote-progress__vendor-header">
    <span class="quote-progress__vendor">{{ vendorName() }}</span>
    <button
      type="button"
      class="quote-progress__download"
      aria-label="View Quote PDF"
      (click)="generateQuotePDF()"
    >
      View Quote PDF
    </button>
  </div>

  @if (hasAnyReclassification()) {
    <div
      class="quote-progress__reclassification-banner"
      role="alert"
      data-testid="job-requirement-change-banner"
    >
      <mat-icon class="quote-progress__banner-icon" aria-hidden="true"
        >info</mat-icon
      >
      <p class="quote-progress__banner-text">
        <strong>Job Requirement Change:</strong> While reviewing your files for
        translation, the vendor identified some changes regarding Desktop
        Publishing needs. If you select this quote, these changes will be
        reflected in the Job Details tab. For more details please expand the
        Document Requirement Changes accordion.
      </p>
    </div>
  }

  <!-- Card -->
  <div class="quote-progress__card">
    <!-- Info row -->
    <div class="quote-progress__info">
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Delivery type</span>
        <span class="quote-progress__info-value">
          <svg
            class="quote-progress__clock-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M10.1839 18.3886C9.03114 18.3886 7.94781 18.1698 6.93392 17.7323C5.92003 17.2948 5.03809 16.7011 4.28809 15.9511C3.53809 15.2011 2.94434 14.3191 2.50684 13.3052C2.06934 12.2913 1.85059 11.208 1.85059 10.0552C1.85059 8.90245 2.06934 7.81912 2.50684 6.80523C2.94434 5.79134 3.53809 4.90939 4.28809 4.15939C5.03809 3.40939 5.92003 2.81564 6.93392 2.37814C7.94781 1.94064 9.03114 1.72189 10.1839 1.72189C11.3367 1.72189 12.42 1.94064 13.4339 2.37814C14.4478 2.81564 15.3298 3.40939 16.0798 4.15939C16.8298 4.90939 17.4235 5.79134 17.861 6.80523C18.2985 7.81912 18.5173 8.90245 18.5173 10.0552C18.5173 10.4302 18.4964 10.7983 18.4548 11.1594C18.4131 11.5205 18.3436 11.8747 18.2464 12.2219C18.052 11.9997 17.8263 11.8122 17.5693 11.6594C17.3124 11.5066 17.0311 11.4024 16.7256 11.3469C16.7673 11.1386 16.7985 10.9268 16.8193 10.7115C16.8402 10.4962 16.8506 10.2774 16.8506 10.0552C16.8506 8.19412 16.2048 6.61773 14.9131 5.32606C13.6214 4.03439 12.045 3.38856 10.1839 3.38856C8.32281 3.38856 6.74642 4.03439 5.45475 5.32606C4.16309 6.61773 3.51725 8.19412 3.51725 10.0552C3.51725 11.9163 4.16309 13.4927 5.45475 14.7844C6.74642 16.0761 8.32281 16.7219 10.1839 16.7219C10.8923 16.7219 11.5693 16.6177 12.2152 16.4094C12.861 16.2011 13.4548 15.9094 13.9964 15.5344C14.1631 15.7705 14.3679 15.9788 14.611 16.1594C14.8541 16.3399 15.1145 16.4788 15.3923 16.5761C14.6839 17.1455 13.8888 17.5899 13.0068 17.9094C12.1249 18.2288 11.1839 18.3886 10.1839 18.3886ZM16.2256 15.0552C15.9339 15.0552 15.6874 14.9545 15.486 14.7531C15.2846 14.5518 15.1839 14.3052 15.1839 14.0136C15.1839 13.7219 15.2846 13.4754 15.486 13.274C15.6874 13.0726 15.9339 12.9719 16.2256 12.9719C16.5173 12.9719 16.7638 13.0726 16.9652 13.274C17.1666 13.4754 17.2673 13.7219 17.2673 14.0136C17.2673 14.3052 17.1666 14.5518 16.9652 14.7531C16.7638 14.9545 16.5173 15.0552 16.2256 15.0552ZM12.9339 13.9719L9.35059 10.3886V5.88856H11.0173V9.72189L14.1006 12.8052L12.9339 13.9719Z"
              fill="#333"
            />
          </svg>
          {{ deliveryType() }}
        </span>
      </div>
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Delivery date</span>
        <span
          class="quote-progress__info-value quote-progress__info-value--bold"
          >{{ deliveryDate() }}</span
        >
      </div>
      <div class="quote-progress__info-col">
        <span class="quote-progress__info-label">Quote ID</span>
        <span
          class="quote-progress__info-value quote-progress__info-value--bold"
          >{{ quoteId() }}</span
        >
      </div>
    </div>

    <!-- Cost breakdown -->
    @if (costBreakdown().length) {
      <div class="quote-progress__breakdown">
        @for (item of costBreakdown(); track item.concept) {
          <div class="quote-progress__breakdown-row">
            @if (item.concept === "Translation cost") {
              <span class="quote-progress__breakdown-concept">
                Estimated linguistic review
              </span>
            } @else {
              <span class="quote-progress__breakdown-concept">{{
                item.concept
              }}</span>
            }
            <span class="quote-progress__breakdown-cost">{{
              item.cost | formatCurrency: currency()
            }}</span>
          </div>
        }
        <div class="quote-progress__total-row">
          <span class="quote-progress__total-label">Total cost</span>
          <span class="quote-progress__total-value">
            {{ totalCost() | formatCurrency: currency() }}
          </span>
        </div>
      </div>
    }

    <!-- 15% buffer note -->
    <p class="quote-progress__buffer-note">
      <strong>Note:</strong> Add a 15% buffer to your purchase order to account
      for potential adjustments in currency, tax, or review costs after file
      preparation.
    </p>

    <!-- Recommended PO Total -->
    <div class="quote-progress__recommended">
      <span class="quote-progress__recommended-label"
        >Recommended PO total</span
      >
      <span class="quote-progress__recommended-value">
        <span class="quote-progress__recommended-pct">+15%</span>=
        {{ recommendedPOTotal() | formatCurrency: currency() }}
      </span>
    </div>
  </div>

  <!-- Purchase Order -->
  <span class="quote-progress__purchase-order">
    <span class="quote-progress__purchase-order-label">Purchase Order:</span>
    <span class="quote-progress__purchase-order-value">{{
      purchaseOrderId()
    }}</span>
  </span>

  <app-document-requirement-changes [detail]="vendorJobDetails()" />

  <app-previous-quotes
    [estimates]="approvedPreviousEstimates()"
    [order]="order()"
    [lowestCostId]="lowestCostId()"
  />
</section>
